import React, {useEffect} from 'react';
import {InputNumber} from 'antd';

const SateFullInputNumber = ({fieldValue, fieldName, isDisabled, value = {}, onChange, setBufferPeriodValue, changeAmount}) => {

    const triggerChange = changedValue => {
        if (onChange) {
          onChange({
            ...value,
            ...changedValue
          });
        }
    };

    useEffect(() => {
        triggerChange({[fieldName]: fieldValue})
    },[])

    useEffect(() => {
        triggerChange({[fieldName]:fieldValue
        })
    },[fieldValue])

    const handleOnChange = (value) => {
    if(setBufferPeriodValue){
        setBufferPeriodValue(value)
    }
        triggerChange({[fieldName] : value})
    }
    
    return (
        <InputNumber disabled={isDisabled}  onChange={number =>  handleOnChange(number)} value={fieldValue} min={0} step={changeAmount} /> 
    )
}

export default SateFullInputNumber;
